import { APP_PREFIX, FLOW_TYPE, COUNTRY } from '../../framework/App/AppConstants';
import { PAGE_NAME } from './pageNames';
import NewCustomerPage from '../pages/NewCustomerPage/NewCustomerPage';
import CycoPage from '../pages/CycoPage/CycoPage';
import BillingAddressPage from '../pages/BillingAddressPage/BillingAddressPage';
import PersonalInformationPage from '../pages/PersonalInformationPage/PersonalInformationPage';
import TermsPage from '../pages/TermsPage/TermsPage';
import DecisionPage from '../pages/DecisionPage/DecisionPage';
import ErrorPage from '../pages/ErrorPage/ErrorPage';
import IneligibilityPage from '../pages/IneligibilityPage/IneligibilityPage';
import InvalidNamePage from '../pages/InvalidNamePage/InvalidNamePage';
import ClosePage from '../../shared-components/ClosePage/ClosePage';
import ContinuePage from '../pages/ContinuePage/ContinuePage';
import AppPendPage from '../pages/AppPendPage/AppPendPage';
import PaymentSecurityPage from '../pages/PaymentSecurityPage/PaymentSecurityPage';

const flowTypes = `${FLOW_TYPE.DIRECT_APP}|${FLOW_TYPE.PROX}|${FLOW_TYPE.HERMES}|${FLOW_TYPE.TESLA}|${FLOW_TYPE.VENICE}`;
const allFlows = `${APP_PREFIX}/(${flowTypes})/${COUNTRY.UNITED_STATES}`;
const allFlowsAndAP = `${APP_PREFIX}/(${flowTypes}|${FLOW_TYPE.APP_PEND})/${COUNTRY.UNITED_STATES}`;

const prodRoutes = [
    {
        path: `${allFlows}/${PAGE_NAME.BILLING_PAGE}`,
        component: BillingAddressPage
    },
    {
        path: `${allFlows}/${PAGE_NAME.PERSONAL_INFO_PAGE}`,
        component: PersonalInformationPage
    },
    {
        path: `${allFlows}/${PAGE_NAME.PAYMENT_SECURITY_PAGE}`,
        component: PaymentSecurityPage
    },
    {
        path: `${allFlows}/${PAGE_NAME.TERMS_PAGE}`,
        component: TermsPage
    },
    {
        path: `${allFlowsAndAP}/${PAGE_NAME.DECISION_PAGE}`,
        component: DecisionPage
    },
    {
        path: `${allFlowsAndAP}/${PAGE_NAME.ERROR_PAGE}`,
        component: ErrorPage
    },
    {
        path: `${allFlows}/${PAGE_NAME.INVALID_NAME_PAGE}`,
        component: InvalidNamePage
    },
    {
        path: `${allFlows}/${PAGE_NAME.INELIGIBLE_PAGE}`,
        component: IneligibilityPage
    },
    {
        path: `${APP_PREFIX}/(${FLOW_TYPE.DIRECT_APP}|${FLOW_TYPE.PROX}|${FLOW_TYPE.HERMES})/${COUNTRY.UNITED_STATES}/${PAGE_NAME.NEWCUST_PAGE}`,
        component: NewCustomerPage
    },
    {
        path: `${APP_PREFIX}/${FLOW_TYPE.VENICE}/${COUNTRY.UNITED_STATES}/${PAGE_NAME.CLOSE_PAGE}`,
        component: ClosePage
    },
    {
        path: `${APP_PREFIX}/${FLOW_TYPE.HERMES}/${COUNTRY.UNITED_STATES}/${PAGE_NAME.CYCO_PAGE}`,
        component: CycoPage
    },
    {
        path: `${APP_PREFIX}/${FLOW_TYPE.HERMES}/${COUNTRY.UNITED_STATES}/${PAGE_NAME.CYCOCORE_PAGE}`,
        component: CycoPage,
        compProps: { isCore: true }
    },
    {
        path: `${allFlows}/${PAGE_NAME.CONTINUE_PAGE}`,
        component: ContinuePage
    },
    {
        path: `${allFlowsAndAP}/${PAGE_NAME.APP_PEND_PAGE}`,
        component: AppPendPage
    }
];

const devRoutes = [
    {
        path: `${APP_PREFIX}/dev/react/ineligibleus`,
        component: IneligibilityPage
    },
    {
        path: `${APP_PREFIX}/dev/react/alreadyhavecreditus`,
        component: IneligibilityPage
    }
];

export default () => {
    if (process.env.NODE_ENV !== 'production') {
        console.log('us react - loading development routes'); // eslint-disable-line
        return [...prodRoutes, ...devRoutes];
    }

    return prodRoutes;
};
